// extracted by mini-css-extract-plugin
module.exports = {"loadMoreRow":"Houses_loadMoreRow__2ZT8V","loadMoreBtn":"Houses_loadMoreBtn__1VtMh","houseProfImg":"Houses_houseProfImg__2pSbf"};